import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

// Glass border https://www.joshwcomeau.com/css/backdrop-filter/

@Component({
  selector: 'navigator',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './navigator.component.html',
  styleUrl: './navigator.component.scss',
})
export class NavigatorComponent {}
